var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.data.avatar!=null ? _vm.data.avatar : '/emptyavatar.png'}})}
var staticRenderFns = []

export { render, staticRenderFns }